module.exports = __webpack_public_path__ + "img/41.254759d.jpg";